import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import cookie from 'vue-cookies';
import i18n from './i18n';
import "@/assets/styles/main.css";
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

createApp(App).use(router).use(store).use(i18n).use(ToastPlugin).use(cookie, {
    secure: true,
}).mount('#app')
